import React, { useState } from "react";

import FeatureFlagsList from "./feature-flags-list";
import SearchBar from "./search-bar";

const UserFeatureFlags = () => {
  const [searchVal, setSearchVal] = useState("");

  return (
    <>
      <SearchBar setSearchVal={setSearchVal} />
      <FeatureFlagsList searchVal={searchVal} />
    </>
  );
};
export default UserFeatureFlags;
